import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { QuillModules } from 'ngx-quill';

@Component({
  selector: 'irembogov-formly-field-html-editor',
  templateUrl: './formly-field-html-editor.component.html',
  styleUrls: [],
})
export class FormlyFieldHtmlEditorComponent extends FieldType<FieldTypeConfig> {
  editorStyle = {
    height: '200px',
  };

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['link'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['clean'],
    ],
  };
}
